export class ShowDashboard{
   
    public crmUserId:number;
  
    public sessionToken:string;
   
    
 
    
 }